import { render } from "./AccountActivityStep.vue?vue&type=template&id=3c2217dd"
import script from "./AccountActivityStep.vue?vue&type=script&lang=js"
export * from "./AccountActivityStep.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__